import { formatDistanceStrict, parseISO } from 'date-fns';

import { config } from '@/config';

export const handleTicketTime = date => formatDistanceStrict(parseISO(date), new Date(), { locale: config.LANG.dateFns });
